import { AxiosResponse } from 'axios';

export enum SaveInspectionQuestionData {
  SET = 'INSPECTION_QUESTION_DATA_SET',
  SENT = 'INSPECTION_QUESTION_DATA_SENT',
  PHOTO_SENT = 'INSPECTION_QUESTION_PHOTO_SENT',
  TASK_SENT = 'INSPECTION_QUESTION_TASK_SENT',
  SET_LOCATION = 'INSPECTION_SET_LOCATION',
  SET_QUESTIONS = 'INSPECTION_SET_QUESTION',
}

export interface TInspectionState {
  readonly status?: boolean;
  readonly sent?: boolean;
  readonly photoSent?: boolean;
  readonly taskSent?: boolean;
  readonly locationId?: number;
  readonly questionId?: number;
  readonly photos?: any;
}

export type TSaveInspectionQuestionDataAction = {
  type:
    | SaveInspectionQuestionData.SET
    | SaveInspectionQuestionData.SENT
    | SaveInspectionQuestionData.PHOTO_SENT
    | SaveInspectionQuestionData.TASK_SENT
    | SaveInspectionQuestionData.SET_LOCATION
    | SaveInspectionQuestionData.SET_QUESTIONS;
  payload: TInspectionState;
};

export interface TApiInspectionPhoto {
  id: number;
  filename: string;
  baseUrl: string;
  mimeType: string;
}

export enum UploadInspectionPhoto {
  REQUEST = 'UPLOAD_INSPECTION_PHOTO_REQUEST',
  SUCCESS = 'UPLOAD_INSPECTION_PHOTO_SUCCESS',
  FAILED = 'UPLOAD_INSPECTION_PHOTO_FAILED',
}

export type TUploadInspectionPhotoAction =
  | {
  type: UploadInspectionPhoto.REQUEST;
}
  | {
  type: UploadInspectionPhoto.SUCCESS;
  payload: AxiosResponse<TApiInspectionPhoto>;
}
  | {
  type: UploadInspectionPhoto.FAILED;
  payload: AxiosResponse<any>;
};

export enum DeleteInspectionPhoto {
  REQUEST = 'DELETE_INSPECTION_PHOTO_REQUEST',
  SUCCESS = 'DELETE_INSPECTION_PHOTO_SUCCESS',
  FAILED = 'DELETE_INSPECTION_PHOTO_FAILED',
}

export type TDeleteInspectionPhotoAction =
  | {
  type: DeleteInspectionPhoto.REQUEST;
}
  | {
  type: DeleteInspectionPhoto.SUCCESS;
  payload: AxiosResponse<{photoId: number}>
}
  | {
  type: DeleteInspectionPhoto.FAILED;
  payload: AxiosResponse<any>;
};

export enum ClearInspectionPhotos {
  SUBMIT = 'CLEAR_INSPECTION_PHOTOS',
};

export type TClearInspectionPhotos = {
  type: ClearInspectionPhotos.SUBMIT;
};

export enum ReportInspectionPhotos {
  REQUEST = 'REPORT_INSPECTION_PHOTOS_REQUEST',
  SUCCESS = 'REPORT_INSPECTION_PHOTOS_SUCCESS',
  FAILED = 'REPORT_INSPECTION_PHOTOS_FAILED',
}

export type TReportInspectionPhotosAction =
  | {
  type: ReportInspectionPhotos.REQUEST;
}
  | {
  type: ReportInspectionPhotos.SUCCESS;
  payload: AxiosResponse<any>;
}
  | {
  type: ReportInspectionPhotos.FAILED;
  payload: AxiosResponse<any>;
};

export enum CreateInspectionTask {
  REQUEST = 'CREATE_INSPECTION_TASK_REQUEST',
  SUCCESS = 'CREATE_INSPECTION_TASK_SUCCESS',
  FAILED = 'CREATE_INSPECTION_TASK_FAILED',
}

export type TInspectionTaskCreateRequest = {
  title: string;
  description: string;
  dueDate: string | null;
  assigneeEmail: string | null;
  notifyAssignee: boolean;
  notifyAssigneeComment: string | null;
  respondentId: string | null;
  questionId: number | null;
  files: Array<{ filename: string; content: string }>;
};

export enum GetInspectionTaskAssignees {
  REQUEST = 'GET_INSPECTION_TASK_ASSIGNEES_REQUEST',
  SUCCESS = 'GET_INSPECTION_TASK_ASSIGNEES_SUCCESS',
  FAILED = 'GET_INSPECTION_TASK_ASSIGNEES_FAILED',
}

export type TGetInspectionTaskAssigneesAction =
  | { type: GetInspectionTaskAssignees.REQUEST }
  | {
      type: GetInspectionTaskAssignees.SUCCESS;
      payload: AxiosResponse<{
        assignees: Array<{ email: string; name: string }>;
      }>;
    }
  | {
      type: GetInspectionTaskAssignees.FAILED;
      payload: AxiosResponse<any>;
    };

export type TCreateInspectionTaskAction =
  | { type: CreateInspectionTask.REQUEST }
  | {
      type: CreateInspectionTask.SUCCESS;
      payload: AxiosResponse<{ taskId: number }>;
    }
  | {
      type: CreateInspectionTask.FAILED;
      payload: AxiosResponse<any>;
    };

export type TInspectionActions =
  | TSaveInspectionQuestionDataAction
  | TUploadInspectionPhotoAction
  | TClearInspectionPhotos
  | TReportInspectionPhotosAction
  | TDeleteInspectionPhotoAction
  | TCreateInspectionTaskAction
  | TGetInspectionTaskAssigneesAction;